import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-067a816e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-content" }
const _hoisted_2 = { class: "header-content__logo" }
const _hoisted_3 = { class: "header-actions" }

import IconBase from '@/components/Icons/IconBase.vue'
import CircleButton from '@/components/Buttons/CircleButton.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseHeaderDemo',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(IconBase, {
        name: "logo",
        width: 80,
        height: 15,
        "view-box": "0 0 80 15"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CircleButton, {
        bg: "theme",
        name: "home",
        iconWidth: 16,
        iconHeight: 18,
        "view-box": "0 0 16 18"
      }),
      _createVNode(CircleButton, {
        bg: "theme",
        name: "profile",
        iconWidth: 16,
        iconHeight: 18,
        "view-box": "0 0 16 18"
      })
    ])
  ]))
}
}

})